import * as Auth from '/b2b/authentication/state/Auth.selectors';
import * as Dashboard from '/b2b/dashboard/state/Dashboard.store';

import Component from './ComplianceCheck.component';
import { connect } from 'react-redux';
import { updateSelectedDomain } from '/b2b/dashboard/views/Dashboard.commands';

const mapStateToProps = state => ({
    customerId: Auth.customer.getId(state),
    selectedDomain: Dashboard.getSelectedDomain(state),
});

const mapDispatchToProps = {
    updateSelectedDomain,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
